import React, { useRef, useEffect } from 'react';
import JSONEditor, { JSONEditorMode } from 'jsoneditor';
import { ConfigType } from 'config/config';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { JSONType } from './JSONEditorWrapper';
import 'brace';
import 'brace/mode/json';
import 'brace/theme/monokai';
import './darkTheme.css';

type JsonEditorProps = {
  json: JSONType;
  setJson: React.Dispatch<React.SetStateAction<ConfigType>>;
  mode: JSONEditorMode;
  modes: JSONEditorMode[];
  enableSort: boolean;
  enableTransform: boolean;
};

const JsonEditor = ({
  json,
  setJson,
  mode,
  modes,
  enableSort,
  enableTransform,
}: JsonEditorProps) => {
  const editorRef = useRef<HTMLDivElement | null>(null);
  const jsonEditorInstance = useRef<JSONEditor | null>(null);

  const handleChange = (updatedJson: ConfigType) => {
    setJson(updatedJson);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `.jsoneditor-poweredBy { display: none !important; }`;
    document.head.appendChild(style);

    if (editorRef.current) {
      jsonEditorInstance.current = new JSONEditor(editorRef.current, {
        mode,
        modes,
        enableSort,
        enableTransform,
        onChange: () => {
          if (jsonEditorInstance.current && handleChange) {
            try {
              const updatedJson = jsonEditorInstance.current.get();
              handleChange(updatedJson);
            } catch (error) {
              console.error('Error parsing JSON:', error);
            }
          }
        },
        navigationBar: false,
        statusBar: false,
        theme: 'ace/theme/monokai',
      });

      if (json) {
        jsonEditorInstance.current.set(json);
      }
    }

    return () => {
      if (jsonEditorInstance.current) {
        jsonEditorInstance.current.destroy();
        jsonEditorInstance.current = null;
      }
    };
  }, []);

  return (
    <Container>
      <Box ref={editorRef} />
    </Container>
  );
};

const Container = styled(Box, { label: 'Container' })(({ theme }) => ({
  height: '100%',
  '& > div': {
    height: '100%',
  },
}));
export default JsonEditor;
